module.exports = __webpack_public_path__ + "img/header-global.9c2a8f3b.jpg";